import { Dialog } from '@angular/cdk/dialog';
import { Injector, inject } from '@angular/core';
import { IConfirmation, provideConfirmation } from '@ral/utils:core/confirmation';
import { provideConfirmationData } from './confirmation-data.provider';
import { ConfirmationComponent } from './confirmation.component';

export const provideAuiConfirmation = provideConfirmation(() => {
    const dialog = inject(Dialog);
    const injector = inject(Injector);

    function confirm(args: IConfirmation) {
        const dialogId = 'confirmation';
        if (dialog.getDialogById(dialogId)) return;

        const dialogInjector = Injector.create({
            parent: injector,
            providers: [provideConfirmationData(args)],
        });

        dialog.open(ConfirmationComponent, {
            id: dialogId,
            closeOnNavigation: true,
            injector: dialogInjector,
        });
    }

    return {
        confirm,
    };
});
